export default {
	"qsrmima": "请输入密码",
	"qsryhmhsjh":"请输入用户名或手机号",
	"login":"登录",
	"yiot":"伊之密工业互联网平台",
}